import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function EventDetailsSkeleton() {
  return (
    <div>
      {/* Hero skeleton */}
      <div className="mb-6">
        <Skeleton className="w-full aspect-[2/1] sm:aspect-[3/1] lg:aspect-[4/1] rounded-lg bg-gray-200 dark:bg-slate-700" />
      </div>

      {/* Two-column layout skeleton */}
      <div className="flex flex-col lg:flex-row lg:gap-8">
        {/* Left: description */}
        <div className="order-2 lg:order-1 lg:flex-1 lg:min-w-0">
          <Skeleton className="h-5 w-20 mb-3 bg-gray-200 dark:bg-slate-700" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full bg-gray-200 dark:bg-slate-700" />
            <Skeleton className="h-4 w-4/5 bg-gray-200 dark:bg-slate-700" />
            <Skeleton className="h-4 w-3/5 bg-gray-200 dark:bg-slate-700" />
          </div>
        </div>

        {/* Right: sessions */}
        <div className="order-1 lg:order-2 lg:w-[380px] lg:shrink-0 mb-6 lg:mb-0">
          <Skeleton className="h-5 w-36 mb-3 bg-gray-200 dark:bg-slate-700" />
          <div className="space-y-3">
            {Array.from({ length: 2 }).map((_, i) => (
              <div
                className="bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 p-4"
                key={i}
              >
                <div className="flex items-center justify-between mb-2">
                  <Skeleton className="h-4 w-40 bg-gray-200 dark:bg-slate-700" />
                  <Skeleton className="h-4 w-20 bg-gray-200 dark:bg-slate-700" />
                </div>
                <Skeleton className="h-4 w-64 mb-1 bg-gray-200 dark:bg-slate-700" />
                <Skeleton className="h-4 w-48 bg-gray-200 dark:bg-slate-700" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
